import React from 'react'
import { Trans, withI18n } from '@lingui/react'
import { shape, arrayOf } from 'prop-types'
import classNames from 'classnames'

import { i18nType } from 'views/utils/propTypes'

import { getProductsSlider, getCategoriesList, getTopicsList } from './helpers'

import './LastActivity.scss'

const LastActivity = ({ categories, products, topics, i18n }) => {
  if (categories.length === 0 && products.length === 0 && topics.length === 0) {
    return null
  }

  const hasCategories = categories.length > 0
  const hasTopics = topics.length > 0

  return (
    <div className="o-LastActivity u-margin-x-large--bottom">
      <h2>
        <Trans id="productSliders.lastActivities.headline" />
      </h2>
      <div className="l-flex l-flex--stretch-children l-flex--wrap">
        {products.length > 0 && (
          <div className="l-col--12-of-12 l-col--6-of-12@medium u-padding-large--right@medium u-margin--bottom@small-tiny">
            {getProductsSlider(
              i18n._('general.label.viewedProducts'),
              products
            )}
          </div>
        )}
        {(hasCategories || hasTopics) && (
          <div className="l-col--12-of-12 l-col--6-of-12@medium">
            {hasCategories && (
              <div className={classNames({ 'u-margin--bottom': hasTopics })}>
                {getCategoriesList(
                  i18n._('general.label.categories'),
                  categories
                )}
              </div>
            )}
            {hasTopics &&
              getTopicsList(i18n._('metaTag.ratgeber.title'), topics)}
          </div>
        )}
      </div>
    </div>
  )
}

LastActivity.propTypes = {
  categories: arrayOf(shape({})),
  products: arrayOf(shape({})),
  topics: arrayOf(shape({})),
  i18n: i18nType.isRequired
}

LastActivity.defaultProps = {
  categories: [],
  products: [],
  topics: []
}

export default withI18n()(LastActivity)
